import React, { ReactElement } from "react";

import MuiSvgIcon from "@mui/material/SvgIcon";
import { SvgIconProps } from "@mui/material/SvgIcon";

const SvgIcon = (props: SvgIconProps): ReactElement => {
  const { color, ...rest } = props;
  return <MuiSvgIcon {...props} color={color || "primary"} {...rest} />;
};
export default SvgIcon;
